export const SET_HAS_LANGUAGE = 'SET_HAS_LANGUAGE';

export const SetHasLanguage = (value) => {
    return {
        type: SET_HAS_LANGUAGE,
        payload: {
            value: value
        }
    }
}